import axios from 'axios';
import * as React from 'react';
import { requestCreateDirectApPlan } from '../asyncHelpers/actionPlanService';
import { ApActionType } from '../sic-lib/enums/ApActionType';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ApPlanActionData } from '../sic-lib/types/ApPlanAction';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncScheduleMessage
 *
 * @description
 * React hook providing request state management and cancellation for the
 * series of requests required to schedule a one-off message
 */
export default function useAsyncScheduleMessage() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncScheduleMessage = async (
        contactId: number,
        actionType: ApActionType,
        clientFieldId: number,
        data: ApPlanActionData,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data: apPlan } = await requestCreateDirectApPlan(
                {
                    title: 'ap title',
                    contactId,
                    actionType,
                    clientFieldId,
                    data: data,
                },
                request_token.token,
            );

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while sending message');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncScheduleMessage,
    };
}
